var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _line, _line2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _line3, _line4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 175,
    viewBox: "0 0 227 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.732 36.4045C176.629 36.4045 179.788 33.2887 179.788 29.4452C179.788 25.6017 176.629 22.4859 172.732 22.4859C168.835 22.4859 165.676 25.6017 165.676 29.4452C165.676 33.2887 168.835 36.4045 172.732 36.4045Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.591 13.3756C82.496 13.3756 84.851 11.053 84.851 8.18782C84.851 5.32267 82.496 3 79.591 3C76.6859 3 74.331 5.32267 74.331 8.18782C74.331 11.053 76.6859 13.3756 79.591 13.3756Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.063 44.5026L30.7113 55.0047",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.063 55.0047L30.7113 44.5026",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.269 61.7711L221.379 66.7311",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.747 71.271L216.901 57.2312",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7961 113.463L3 131.557C3 131.936 3.38488 132.316 3.76976 132.063L20.5761 124.471C20.961 124.344 20.961 123.838 20.7044 123.585L5.69415 113.083C5.30927 112.83 4.7961 113.083 4.7961 113.463Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.536 112.956H205.061C204.677 112.956 204.42 113.336 204.548 113.716L213.785 129.532C214.042 129.912 214.555 129.912 214.683 129.532L223.921 113.716C224.177 113.463 223.921 112.956 223.536 112.956Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.4471,
    y: 68.4588,
    width: 136.553,
    height: 105.635,
    rx: 8,
    fill: "#D7D5FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 56.5,
    width: 131.553,
    height: 100.635,
    rx: 5.5,
    fill: "white",
    stroke: "#4147EB",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64.8176,
    y1: 91.8647,
    x2: 80.4294,
    y2: 91.8647,
    stroke: "#DEDBFE",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64.8176,
    y1: 125.359,
    x2: 80.4294,
    y2: 125.359,
    stroke: "#DEDBFE",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.0353,
    y: 101.235,
    width: 28.3412,
    height: 9.44706,
    rx: 4.72353,
    fill: "#4147EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.0353,
    y: 134.729,
    width: 28.3412,
    height: 9.44706,
    rx: 4.72353,
    fill: "#4147EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 115.565,
    y: 101.235,
    width: 46.3765,
    height: 9.44706,
    rx: 4.72353,
    fill: "#4147EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 96.6706,
    y: 101.235,
    width: 15.4588,
    height: 9.44706,
    rx: 4.72353,
    fill: "#ADABFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96.6706,
    y: 134.729,
    width: 15.4588,
    height: 9.44706,
    rx: 4.72353,
    fill: "#ADABFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 115.565,
    y: 134.729,
    width: 15.4588,
    height: 9.44706,
    rx: 4.72353,
    fill: "#ADABFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 134.459,
    y: 134.729,
    width: 27.4824,
    height: 9.44706,
    rx: 4.72353,
    fill: "#ADABFF"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 48.5765,
    y1: 73.8294,
    x2: 179.976,
    y2: 73.8294,
    stroke: "#4147EB",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 58.8059,
    y1: 64.3824,
    x2: 73.5588,
    y2: 64.3824,
    stroke: "#4147EB",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/Schedule.cb508d2d025b263993784f38b73bac41.svg";
export { ForwardRef as ReactComponent };